/* eslint-disable @typescript-eslint/no-explicit-any */
import { HomeContainer } from '@/components/common'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { CoolcashBenefitModal } from './coolcash-benefit-modal'

export const CoolClubBenefitsSection = () => {
  const t = useTranslations()

  const benefits = [
    {
      image: '/image/January2025/mceclip6.png',
      keyBenefit: 'free',
    },
    {
      image: '/image/January2025/mceclip5.png',
      keyBenefit: 'cashback',
    },
    {
      image: '/image/January2025/mceclip7.png',
      keyBenefit: 'save',
    },
    {
      image: '/image/January2025/mceclip0_46.png',
      keyBenefit: 'birthday',
    },
  ]

  return (
    <>
      <HomeContainer>
        <h2 className='mb-6 text-center font-criteria text-[28px] font-semibold leading-10 text-neutral-900'>
          {' '}
          {t('landing_coolclub_page.benefits.title')}
          <br className='lg:hidden' />
        </h2>
        <div className='space-y-10 lg:hidden'>
          {benefits.map((benefit) => (
            <BenefitItem {...benefit} key={benefit.keyBenefit} />
          ))}
        </div>

        <Carousel
          opts={{
            align: 'start',
            duration: 50,
            slidesToScroll: 2,
            skipSnaps: true,
          }}
          className='w-full max-lg:hidden'
        >
          <CarouselContent className='ml-0 will-change-transform'>
            {benefits.map((benefit) => (
              <CarouselItem className='basis-2/6' key={benefit.keyBenefit}>
                <BenefitItem {...benefit} key={benefit.keyBenefit} />
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious
            className='absolute -left-4 top-1/2 h-10 w-10 -translate-y-1/2 lg:-left-10'
            variant='black'
            hideIfStart
          />
          <CarouselNext
            className='absolute -right-4 top-1/2 h-10 w-10 -translate-y-1/2 lg:-right-10'
            variant='black'
            hideIfEnd
          />
        </Carousel>
      </HomeContainer>
      <div className='flex h-[330px] flex-col items-center bg-[url(https://mcdn.coolmate.me/image/January2025/mceclip9_56.jpg)] bg-cover bg-center py-12 md:rounded-3xl md:py-20 lg:bg-[url(https://mcdn.coolmate.me/image/January2025/mceclip8.png)]'>
        <div className='font-criteria text-3xl font-semibold md:text-5xl'>
          {t('landing_coolclub_page.coolcash.title')}
        </div>
        <div className='my-2 text-center text-sm font-normal text-[#28104E] md:mb-7 md:mt-4 md:text-lg'>
          {t('landing_coolclub_page.coolcash.description')}
        </div>
        <CoolcashBenefitModal />
      </div>
    </>
  )
}

const BenefitItem = ({
  image,
  keyBenefit,
}: {
  image: string
  keyBenefit: string
}) => {
  const t = useTranslations()
  return (
    <div className='flex flex-col items-center justify-center gap-2'>
      <Image
        src={ImageHelper.getImageUrl(image)}
        alt='Benefit'
        width={334}
        height={157}
        className='max-h-40 object-contain'
      />
      <p className='text-center font-criteria text-2xl font-semibold leading-9 text-neutral-900'>
        {t(`landing_coolclub_page.benefits.items.${keyBenefit}.title` as any)}
      </p>
      <p className='text-center font-sans text-base font-normal text-neutral-900'>
        {t(
          `landing_coolclub_page.benefits.items.${keyBenefit}.description` as any
        )}
      </p>
    </div>
  )
}
